/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/paragraph_medium'
export default icon
